import { defineModal, Loader, Modal } from '@libs/ui/ds'
import { useMemoSelector } from '@spa/redux/hooks'
import type { FC } from 'react'
import { getRestById } from 'snap-redux/modules/rests/selectors'

import { RestForm } from '../../Forms'
import { contractsSelectors } from '../../redux/selectors'

type RestModalProps = {
  restId: number
  userContractId?: number
  teamId?: number
  onSuccess?: () => void
}

export const restModalDef = defineModal<RestModalProps>({
  name: 'editRestModal'
})

const RestModal: FC = () => {
  const { close, isOpen, data } = restModalDef.useModal()
  const isLoading = useMemoSelector(state => {
    return (
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      !getRestById(state, data.restId) ||
      // On the Month View the contract is not already fetched at the time the modal tries to open
      (data?.userContractId &&
        !contractsSelectors.getCachedById(state, data?.userContractId))
    )
  })

  if (isLoading) {
    return <Loader.Container />
  }

  return (
    <Modal opened={isOpen} onClose={close} variant='right'>
      <RestForm
        onFormSuccess={() => {
          data?.onSuccess?.()
          close()
        }}
        restId={data?.restId}
        teamId={data?.teamId}
      />
    </Modal>
  )
}

export default restModalDef.withModalShow(RestModal)
